import { Text, View } from 'react-native'
import { styled } from '~/core/styled'
import { convertLineHeight, convertPercentageToNumber } from '~/utils'

export const Container = styled(View, theme => {
  return {
    base: {
      width: 'auto',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
    },
  }
})

export const Title = styled(Text, theme => {
  return {
    base: {
      fontFamily: theme.fontFamily.semiBold,
      fontSize: theme.fontSizeThreepulse,
      width: '100%',
      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightMedium
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      paddingLeft: theme.spacingInlineOnepulse,
    },
  }
})
